import React from "react";

/* Double-slash logo mark — brown (#8B6B4A) + pink (#E8758A) on white.
   Matches the approved mockup exactly. */

export function LogoMark({ size = 36 }) {
  // Scale transforms proportionally
  const scale = size / 36;
  return (
    <svg width={size} height={size} viewBox="0 0 36 36" fill="none">
      <rect width="36" height="36" rx="8" fill="#FFFFFF" stroke="#E0DDD8" strokeWidth="1" />
      <rect x="11" y="4" width="4.5" height="28" rx="2.25" fill="#8B6B4A" transform="rotate(-15 13.25 18)" />
      <rect x="20.5" y="4" width="4.5" height="28" rx="2.25" fill="#E8758A" transform="rotate(-15 22.75 18)" />
    </svg>
  );
}

export function LogoMarkSmall({ size = 18 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 18 18" fill="none">
      <rect width="18" height="18" rx="4" fill="#FFFFFF" stroke="#E0DDD8" strokeWidth="0.5" />
      <rect x="5.5" y="2" width="2.5" height="14" rx="1.25" fill="#8B6B4A" transform="rotate(-15 6.75 9)" />
      <rect x="10" y="2" width="2.5" height="14" rx="1.25" fill="#E8758A" transform="rotate(-15 11.25 9)" />
    </svg>
  );
}
